
import { tracs_api, tracs_api_bg } from "../../services/api.interceptor";
import { JobType, SearchOutputFileInput } from "../interfaces/jobmodels";

class JobService{
    getJobStatuses(){
        
        return tracs_api
        .post(process.env.REACT_APP_TABLEGEN_API+ "LookUp/GetJobStatuses");
    }
    getJobLogTypes(){
        
        return tracs_api
        .post(process.env.REACT_APP_TABLEGEN_API+ "LookUp/GetJobLogTypes");
    }
    getFilterTimePeriods(){
        
        return tracs_api
        .post(process.env.REACT_APP_TABLEGEN_API+ "LookUp/GetFilterTimePeriods");
    }

    getJobs(includeReleased:boolean,type:JobType,timePeriod:string,statusId:string,jobNo:string|null,onlyMyJobs:boolean,rowCount:number=0){
        let toc=null;

        let tocfromStorage=localStorage.getItem('Toc');
        if(tocfromStorage){
            toc=JSON.parse(tocfromStorage);
        }
        return tracs_api
        .post(process.env.REACT_APP_TABLEGEN_API+ "Job/GetJobs",
        {TocId:(toc?toc?.Id:0),IncludeReleased:includeReleased,TypeId:type,
            TimePeriod:Number.parseInt(timePeriod),StatusId:Number.parseInt(statusId),JobNumber:jobNo,OnlyForCurrentUser:onlyMyJobs,RowCount:rowCount});
    }

    getJobsBg(includeReleased:boolean,type:JobType,timePeriod:string,statusId:string,jobNo:string|null,onlyMyJobs:boolean,rowCount:number=0){
        let toc=null;

        let tocfromStorage=localStorage.getItem('Toc');
        if(tocfromStorage){
            toc=JSON.parse(tocfromStorage);
        }
        return tracs_api_bg
        .post(process.env.REACT_APP_TABLEGEN_API+ "Job/GetJobs",
        {TocId:(toc?toc?.Id:0),IncludeReleased:includeReleased,TypeId:type,
            TimePeriod:Number.parseInt(timePeriod),StatusId:Number.parseInt(statusId),JobNumber:jobNo,OnlyForCurrentUser:onlyMyJobs,RowCount:rowCount});
    }

    

    getTasks(jobId:number){
        return tracs_api
        .post(process.env.REACT_APP_TABLEGEN_API+ "Job/GetTasks?jobId="+jobId);
    }

    getTasksBg(jobId:number){
        return tracs_api_bg
        .post(process.env.REACT_APP_TABLEGEN_API+ "Job/GetTasks?jobId="+jobId);
    }

    startJobs(){
        // let toc=null;

        // let tocfromStorage=localStorage.getItem('Toc');
        // if(tocfromStorage){
        //     toc=JSON.parse(tocfromStorage);
        // }
        // return tracs_api
        // .post(process.env.REACT_APP_TABLEGEN_API+ "Job/StartJobs?tocId="+toc?.Id);
    }

    getJobLogs(jobId:number){
        return tracs_api
        .post(process.env.REACT_APP_TABLEGEN_API+ "Job/GetLogs?jobId="+jobId);
    }

    getJobLogsBg(jobId:number){
        return tracs_api_bg
        .post(process.env.REACT_APP_TABLEGEN_API+ "Job/GetLogs?jobId="+jobId);
    }

    getTaskLogs(taskId:number){
        return tracs_api
        .post(process.env.REACT_APP_TABLEGEN_API+ "Job/GetLogs?taskId="+taskId);
    }

    getFileDownload(fileName:string,typeId:number,searchType:number){
        let data={FileName:fileName,TypeId:typeId,SearchType:searchType}
        
        return tracs_api
        .post(process.env.REACT_APP_TABLEGEN_API+ "Job/DownloadFile",data,{
            responseType:"arraybuffer"
            
        });
    }

    GetOutputFiles(inputs: SearchOutputFileInput | null | undefined){
        let toc=null;

        let tocfromStorage=localStorage.getItem('Toc');
        if(tocfromStorage){
            toc=JSON.parse(tocfromStorage);
        }
        return tracs_api
        .post(process.env.REACT_APP_TABLEGEN_API+ "Job/GetOutputFiles",
        inputs!=null ? {
            TocId:(toc?toc?.Id:0),
           ParentSearchType: inputs.ParentSearchType.valueOf(),
           TypeId : inputs.TypeId?.valueOf(),
           IncludeJobsWithoutFile:false
        } :  {TocId:toc?.Id});
    }

    getReleasedTables(ticketTypes:number[],nlcs:number[],jobIds:number[],includeGlobal:boolean,searchType:string){
        let toc=null;

        let tocfromStorage=localStorage.getItem('Toc');
        if(tocfromStorage){
            toc=JSON.parse(tocfromStorage);
        }
        return tracs_api
        .post(process.env.REACT_APP_TABLEGEN_API+ "Job/GetReleaseTables",{TicketTypes:ticketTypes,
            NlcIds:nlcs,IncludeGlobalTables:includeGlobal,JobIds:jobIds,TocId:(toc?toc?.Id:0),SearchType:Number.parseInt(searchType)});
    }

    getReleaseFileNames(taskIds:(number|null)[]){
        return tracs_api
        .post(process.env.REACT_APP_TABLEGEN_API+ "Job/GetReleaseFileNames",{TaskIds:taskIds});
    }

    getReleaseFolder(date:Date){
        let toc=null;

        let tocfromStorage=localStorage.getItem('Toc');
        if(tocfromStorage){
            toc=JSON.parse(tocfromStorage);
        }
        return tracs_api
        .post(process.env.REACT_APP_TABLEGEN_API+ "Job/GetReleaseFolder",{InputDate:date,TocId:(toc?toc?.Id:0)});
    }

    initiateReleaseJob(releaseDate:Date,releaseVersion:number,taskIds:number[],description:string){
        return tracs_api
        .post(process.env.REACT_APP_TABLEGEN_API+ "Job/InitiateReleaseJob",
        {Version:releaseVersion,ReleaseDate:releaseDate,TaskIds:taskIds,Description:description});
    }

    getBuildOutputFolders(){
        let toc=null;
        let tocfromStorage=localStorage.getItem('Toc');
        if(tocfromStorage){
            toc=JSON.parse(tocfromStorage);
        }
        return tracs_api
        .post(process.env.REACT_APP_TABLEGEN_API+ "Job/GetBuildOutputFolders?tocId="+(toc?toc?.Id:0));
    }

    getReleaseOutputFolders(){
        let toc=null;
        let tocfromStorage=localStorage.getItem('Toc');
        if(tocfromStorage){
            toc=JSON.parse(tocfromStorage);
        }
        return tracs_api
        .post(process.env.REACT_APP_TABLEGEN_API+ "Job/GetReleaseOutputFolders?tocId="+(toc?toc?.Id:0));
    }

    getOutputTableDetails(tableId:number){
        return tracs_api
        .post(process.env.REACT_APP_TABLEGEN_API+ "OutputTable/GetOutputTableDetails?tableId="+tableId);
    }

     
}

export default new JobService();